<template>
    <ul class="playlist">
      <li span v-for="(song, index) in songs" v-if="$t(song.file)"  :class="{active: playing === index}" @click="toggle(index)" @ended="pause()">
            <span class="play glyphicon glyphicon-play"></span>
            <span class="pause glyphicon glyphicon-pause"></span>
            <span>{{$t(song.name)}}</span>
            <audio :id="'playback-' + index">
                <source :src="$t(song.file)" type="audio/mpeg">
            </audio>
      </li>
    </ul>
</template>

<script>
export default {
  name: "ruth-audio",
  data: function() {
    return {
      playing: -1,
      songs: [
        {
          name: "audio.Betlehem.name",
          file: "audio.Betlehem.path"
        },
        {
          name: "audio.Dreh-die-Zeit.name",
          file: "audio.Dreh-die-Zeit.path"
        },
        {
          name: "audio.Freudentag.name",
          file: "audio.Freudentag.path"
        },
        {
          name: "audio.Was-wird-morgen.name",
          file: "audio.Was-wird-morgen.path"
        },
        {
          name: "audio.Psalm-23.name",
          file: "audio.Psalm-23.path"
        }
      ]
    };
  },
  mounted: function() {
    let app = this;
    $(".playlist li audio").each(function() {
      this.addEventListener("ended", app.pause);
    });
  },
  methods: {
    toggle: function(index) {
      if (this.playing !== index) {
        this.play(index);
      } else {
        this.pause();
      }
    },
    play: function(index) {
      this.pause(this.playing);
      this.playing = index;
      let audio = $(".playlist li audio#playback-" + index)[0];
      audio.load();
      audio.play();
    },
    pause: function() {
      if (this.playing !== -1) {
        let audio = $(".playlist li audio#playback-" + this.playing)[0];
        audio.pause();
        audio.currentTime = 0;
        this.playing = -1;
      }
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/scss/texture-sub";
@import "../../assets/scss/var";

.playlist {
  width: 600px;
  margin: 0 auto;
  list-style: none;

  @include media-tablet {
    width: 100%;
    padding: 0 20px;
  }

  li {
    font-size: 30px;
    padding: 10px 0;

    @include media-phone {
      font-size: 20px;
    }

    span {
      cursor: pointer;
    }

    &.active .glyphicon.pause {
      display: inline-block;
    }

    &:not(.active) .glyphicon.play {
      display: inline-block;
    }

    .glyphicon {
      display: none;
      width: 40px;
      height: 40px;
      font-size: 27px;
      background-image: $texture;
      background-size: 500%;
      border-radius: 50%;
      padding: 6px 7px;
      text-align: center;
      color: #000;
      margin-right: 5px;

      @include media-phone {
        height: 25px;
        width: 25px;
        font-size: 13px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MainSegments/Audio.vue